/**
 * External dependencies.
 */
import PropTypes from 'prop-types';
import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Header from "./header"

const HeaderPL = ({ translated }) => {
  return (
    <StaticQuery
      query={graphql`
				    query HeaderQueryPL {
						wpgraphql {
							themesOptionsPage {
								template {
									header {
                    homepage
                    searchpage
                    myaccountpage
										topbanner
                    searchPlaceholder
                    searchButton
										logo {
                      sourceUrl
                      databaseId
                      modified
                      imageFile {
                        childImageSharp {
                          fluid(maxWidth: 150) {
                            base64
                            aspectRatio
                            src
                            srcSet
                            sizes
                            srcWebp
                            srcSetWebp
                          }
                        }
                      }
										}
                    nav {
                      item {
                        url
                        title
                        target
                      }
                      subnav {
                        item {
                          target
                          title
                          url
                        }
                      }
                    }
										helpline {
											target
											title
											url
										}
									}
								}
							}
						}
				  }` }
      render={data => <Header dataTemplate={data.wpgraphql.themesOptionsPage} translated={translated} menu={data.wpgraphql.menu} />}
    />
  )
}

HeaderPL.propTypes = {
  lang: PropTypes.string,
};

HeaderPL.defaultProps = {
  lang: 'pl',
  data: {
    wpgraphql: {}
  },
};

export default HeaderPL